export const formatDate = (date: Date) => {
  const year = date.getFullYear().toString().substr(-2);
  let month = (date.getMonth() + 1).toString();
  month = month.length === 1 ? `0${month}` : month;
  let day = date.getDate().toString();
  day = day.length === 1 ? `0${day}` : day;
  return day + month + year;
};
